import ErrorHandler from './error-handler'
// let gateway = 'http://localhost:4000'
// let gateway = 'https://rubisuat.purplefire.com:5000'
let gateway = 'https://selfregrwapi.volanedev.com'
// let gateway = 'https://cardapplication.rubisrwanda.com'
let endpoint = gateway + '/api/web/v1'
let options = {
   mode: 'cors',
   headers: {}
}

export default class API {
   constructor() {
      this.endpoint = endpoint
      this.errHandler = new ErrorHandler()
   }

   fetch(route, data, opt) {
      return new Promise(async (resolve, reject) => {
         try {
            if (Object.keys(data).length > 0) {
               data = JSON.stringify(data)
            } else {
               data = undefined
            }

            let req = this.setOptions({ body: data }, options)
            req = this.setOptions(req, opt)

            if (req.method === 'POST') {
               req.headers['Content-Type'] = 'application/json'
            }
            if (opt) {
               req = this.setOptions(req, opt)
            }

            let res = await fetch(route, req)
            let body = await res.text()

            if (body === '') { body = undefined }
            if (this.isJson(body)) {
               body = JSON.parse(body)
            }

            if (!res.ok) {
               throw body
            }

            resolve(body)
         } catch (err) {
            console.log(err)
            await this.errHandler.handleError(err)
            reject(err)
         }
      })
   }

   fetchEndpoint(data, route, opt) {
      return new Promise(async (resolve, reject) => {
         try {
            if (!route) { route = '' }
            if (!opt) { opt = { method: 'POST' } }

            if (Object.keys(data).length > 0) {
               data = JSON.stringify(data)
            } else {
               data = undefined
            }

            let req = this.setOptions({ body: data }, options)
            req = this.setOptions(req, opt)

            if (req.method === 'POST') {
               req.headers['Content-Type'] = 'application/json'
            }
            if (opt) {
               req = this.setOptions(req, opt)
            }

            let res = await fetch(this.endpoint + route, req)
            let body = await res.text()

            if (body === '') { body = undefined }
            if (this.isJson(body)) {
               body = JSON.parse(body)
            }

            if (!res.ok) {
               throw body
            }

            resolve(body)
         } catch (err) {
            await this.errHandler.handleError(err)
            reject(err)
         }
      })
   }

   fetchEndpointSecure(data, route, opt) {
      return new Promise(async (resolve, reject) => {
         if (!route) { route = '' }
         if (!opt) { opt = { method: 'POST' } }

         try {
            if (Object.keys(data).length > 0) {
               data = JSON.stringify(data)
            } else {
               data = undefined
            }

            let req = this.setOptions({ body: data }, options)
            req = this.setOptions(req, opt)

            // fetch the token and logout user if token is not found
            let token = await $session.get('token')
            if (token) {
               req.headers['Authorization'] = `Bearer ${token}`
            } else {
               EventBus.$emit('token:not-found', true)
               return reject(false)
            }


            if (req.method === 'POST') {
               req.headers['Content-Type'] = 'application/json'
            }
            if (opt) {
               req = this.setOptions(req, opt)
            }

            let res = await fetch(this.endpoint + route, req)
            let body = await res.text()

            // if (body === '') { body = undefined }
            if (this.isJson(body)) {
               body = JSON.parse(body)
            }

            if (!res.ok) {
               throw body
            }

            resolve(body)
         } catch (err) {
            await this.errHandler.handleError(err)
            reject(err)
         }
      })
   }

   upload(route, data, name) {
      return new Promise(async (resolve, reject) => {
         let ajax = new XMLHttpRequest(), token = await $session.get('token'), id = this.generateRandomHex(6)
         if (!token) {
            EventBus.$emit('token:not-found', true)
            return reject(false)
         }

         //TODO: code to store an upload to a session in case it fails it can be restarted
         // send event to notify new upload
         EventBus.$emit('upload_notification:create', { id, name })

         // on progress
         ajax.upload.addEventListener("progress", (event) => {
            let percent = (event.loaded / event.total) * 100;

            // send event to notify progress
            EventBus.$emit('upload_notification:progress', {
               id,
               current: this.bytesToSize(event.loaded),
               total: this.bytesToSize(event.total),
               progress: percent
            }, id)
         }, false);

         // on complete
         ajax.addEventListener("load", (event) => {
            EventBus.$emit('upload_notification:complete', { id })
         }, false);

         // on error
         ajax.addEventListener("error", async (event) => {
            // await this.errHandler.handleError(err)
            reject(event)
         }, false);

         // on abort
         ajax.addEventListener("abort", (event) => {
            reject(event)
         }, false);

         ajax.onreadystatechange = function() {
            if (ajax.readyState == XMLHttpRequest.DONE) {
               resolve(JSON.parse(ajax.responseText));
            }
         }

         // post request
         ajax.open("POST", route,true);
         ajax.setRequestHeader('Authorization', `Bearer ${token}`)
         ajax.send(data);
      })
   }

   parseRoute(route) {
      return `${gateway}${route}`
   }

   setOptions(data, opt) {
      Object.keys(opt).forEach(function (key) {
         data[key] = opt[key]
      })

      return data
   }

   isJson(data) {
      if (data !== null && data !== undefined && /^[\],:{}\s]*$/.test(data.replace(/\\["\\\/bfnrtu]/g, '@').
         replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
         replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
         return true;
      }

      return false
   }

   progressHandler(event) {
      let percent = (event.loaded / event.total) * 100;

      // send event to notify progress
      EventBus.$emit('upload_notification:progress', {
         id: _id,
         current: this.bytesToSize(event.loaded),
         total: this.bytesToSize(event.total),
         progress: percent
      })
   }

   generateRandomHex(len) {
      let options = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'], hex = ''
      for (let i = 0; i < len; i++) {
         const letter = options[Math.round(Math.random() * 15)];
         hex += letter
      }

      return hex;
   }

   bytesToSize(bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
   }
}
